import React from "react";
import ToggleBtn from "../SidebarComponent/ToggleBtn/ToggleBtn";
import "./Nav.css";
import { useNavigate } from "react-router-dom";

function UnAuthNav(props: any) {
  return (
    <nav className="navbar navbar-expand-lg  position-sticky top-0">
      <div className="container-fluid d-flex align-items-center px-4 py-2">
        {/* <ToggleBtn /> */}

        <a
          className="navbar-brand "
          href="/">
          <img
            className="navbar-img"
            src={require("../../assets/img/engage ai_logo_slate.png")}
            alt=""
          />
        </a>
      </div>
    </nav>
  );
}

export default UnAuthNav;
